<style lang="less" scoped>
  .detail-from-input {
    width: 450px;
    margin: 10px 30px;
  }
  
  .detail-form-logo {
    margin: 16px 20px;
  }
  
  .margin-bt-10 {
    margin-bottom: 40px;
  }
  
  .detail-body-title {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  
  .upload-logo {
    width: 30%;
  }
  
  .app-card-style img {
    width: 350px;
    height: 160px;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .app-card-style {
    display: flex;
    flex-direction: column;
  }
  
  .box {
    position: relative;
    width: 348px;
    height: 160px;
    overflow: hidden;
    border: 3px solid #4390df;
    border-radius: 6px;
  }
  
  .box:before {
    position: absolute;
    display: block;
    border-top: 20px solid #4390df;
    border-left: 20px solid transparent;
    right: 0;
    top: 0;
    content: "";
    z-index: 101;
  }
  
  .box:after {
    position: absolute;
    display: block;
    content: "\2714";
    top: -3px;
    right: 0;
    font-family: Glyphicons Halflings;
    font-size: 3pt;
    font-weight: normal;
    z-index: 102;
    color: #fff;
  }
  
  .img-div {
    margin: 10px 45px;
  }
  
  .detail-table {
    margin-top: 20px;
  }

</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"/>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-form
          ref="detailForm"
          :model="detailForm"
          :rules="pageConfig.formRules"
          class="detail-form"
        >
          <div class="detail-form-parent-div">
            
            <div class="margin-bt-10">
              <div class="detail-body-title">公司信息</div>
              <div class="flex">
                <el-form-item
                  class="detail-from-input"
                  label="清分账户名称："
                  prop="companyName"
                >
                  <el-input
                    v-model="detailForm.accountName"
                    clearable
                    placeholder="请输入内容"
                    size="small"
                  />
                </el-form-item>
                <el-form-item
                  class="detail-from-input"
                  label="运营商名称："
                  prop="dealAbbrName"
                >
                  <el-select
                    v-model="detailForm.dealNo"
                    class="full-width"
                    clearable
                    filterable
                    placeholder="请选择运营商名称"
                    size="small"
                  >
                    <el-option
                      v-for="item in dealerArr"
                      :key="item.id"
                      :label="item.dealName"
                      :value="item.dealNo"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item
                  class="detail-from-input"
                  label="清分账户类型："
                  prop="dealAbbrName"
                >
                  <el-select
                    v-model="detailForm.accountType"
                    class="full-width"
                    clearable
                    filterable
                    placeholder="请选择清分账户类型"
                    size="small"
                  >
                    <el-option label="运营商" value="Operators"/>
                    <el-option label="合作方" value="Collaborators"/>
                    <el-option label="代理商" value="Agent"/>
                    <el-option label="场地方" value="FieldProvider"/>
                    <el-option label="物业方" value="Property"/>
                  </el-select>
                </el-form-item>
              </div>
              <div class="flex">
                <el-form-item
                  class="detail-from-input"
                  label="分成站点："
                  prop="serviceTel"
                >
                  <el-select
                    v-model="detailForm.stationNo"
                    class="full-width"
                    clearable
                    filterable
                    size="small"
                  >
                    <el-option
                      v-for="item in powerStationArr"
                      :key="item.stationNo"
                      :label="item.stationName"
                      :value="item.stationNo"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  class="detail-from-input"
                  label="微信商户全称"
                  prop="wxMerchantName"
                >
                  <el-input
                    v-model="detailForm.wxMerchantName"
                    maxlength="25"
                    size="small"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  class="detail-from-input"
                  label="账户状态："
                  prop="turnoverMerchantCode"
                >
                  <el-select
                    v-model="detailForm.accountStatus"
                    class="full-width"
                    clearable
                    filterable
                    placeholder="请选择账户状态"
                    size="small"
                  >
                    <el-option label="待认证" value="NOT_CERTIFIED"/>
                    <el-option label="已认证，待设置" value="NOT_CONFIG"/>
                    <el-option label="使用中" value="RUNNING"/>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            
            <div class="margin-bt-10">
              <div class="detail-body-title">分成站点设置</div>
              <el-button
                size="small"
                type="primary"
                @click="handleAddStation('新增站点')"
              >
                新 增
              </el-button>
              <el-table
                v-if="editFlag"
                ref="listTableRef"
                :data="clearAccountList"
                :stripe="true"
                border
                class="detail-table"
              >
                <el-table-column align="center" label="参与分成站点" min-width="150" prop="stationName"/>
                <el-table-column align="center" label="分成类型" min-width="150" prop="splitTypeName"/>
                <el-table-column align="center" label="分成方式" min-width="150" prop="amountSplitPercent">
                  <template slot-scope="scope">
                    <span v-if="scope.row.splitType === 'AMOUNT'">
                      按{{ scope.row.splitTypeName }} {{ scope.row.amountSplitPercent }} %
                    </span>
                    <span v-if="scope.row.splitType === 'DEGREE'">
                      按{{ scope.row.splitTypeName }} {{ scope.row.eachDegreeSplitPrice }} 元
                    </span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="分成周期" min-width="150" prop="dividedCyclesName"/>
                <el-table-column align="center" label="提现周期" min-width="150" prop="payoutCyclesName"/>
                <el-table-column align="center" label="备用金（元）" min-width="150" prop="reserveAmount"/>
                <el-table-column align="center" label="分成状态" min-width="150" prop="splitActiveStatusName"/>
                <el-table-column align="center" label="提现状态" min-width="180" prop="splitPayoutStatusName"/>
                <el-table-column align="center" label="操作" min-width="180">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="handleAddStation('编辑站点', scope.row)">编 辑</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            
            <el-divider></el-divider>
            
            <div class="detail-body-title">开票规则设置</div>
            <div class="margin-bt-10">
              <div class="flex">
                <el-form-item class="detail-from-input" label="发票抬头" prop="invoiceTitle">
                  <el-input v-model="detailForm.invoiceTitle" size="small"/>
                </el-form-item>
                <el-form-item class="detail-from-input" label="发票类型" prop="invoiceType">
                  <el-select v-model="detailForm.invoiceType" size="small" style="width: 100%">
                    <el-option label="增值税专用发票" value="增值税专用发票"/>
                    <el-option label="增值税普通发票" value="增值税普通发票"/>
                  </el-select>
                </el-form-item>
                <el-form-item class="detail-from-input" label="发票税率" prop="invoiceTaxVal">
                  <el-select v-model="detailForm.invoiceTaxVal" size="small" style="width: 100%">
                    <el-option v-for="item in 31" :key="item" :label="(item - 1) + '%'" :value="(item - 1 ) + '%'"/>
                  </el-select>
                </el-form-item>
              </div>
              <div class="flex">
                <el-form-item class="detail-from-input" label="发票内容" prop="invoiceContext">
                  <el-input v-model="detailForm.invoiceContext" :rows="4" size="small" type="textarea"/>
                </el-form-item>
              </div>
            </div>
            
            <el-divider></el-divider>
            
            <div class="detail-body-title">相关合同</div>
            <div class="margin-bt-10">
              <div class="flex">
                <el-form-item class="detail-from-input" label="签约时间" prop="contractStart">
                  <el-date-picker v-model="detailForm.contractStart" placeholder="选择签约时间" size="small"
                                  style="width: 100%"
                                  type="date"
                                  value-format="yyyy-MM-dd"/>
                </el-form-item>
                <el-form-item class="detail-from-input" label="到期时间" prop="contractEnd">
                  <el-date-picker v-model="detailForm.contractEnd" placeholder="选择到期时间" size="small"
                                  style="width: 100%"
                                  type="date"
                                  value-format="yyyy-MM-dd"/>
                </el-form-item>
              </div>
            </div>
            <el-upload
              :before-remove="beforeRemove"
              :file-list="fileList"
              :http-request="toUploadcontractFile"
              :on-exceed="handleExceed"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              action=""
              class="upload-demo"
              multiple
            >
              <el-button size="small" type="primary">
                上传合同附件
              </el-button>
              <div slot="tip" class="el-upload__tip"></div>
            </el-upload>
            <el-table
              v-if="editFlag"
              ref="listTableRef"
              :data="dealerFileDtoList"
              :stripe="true"
              border
              class="detail-table"
              style="width: 100%"
            >
              <el-table-column align="center" type="index" width="50"/>
              <el-table-column align="center" label="合同名称" min-width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.contractName }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="上传时间" min-width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.lastModifiedWhen }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" min-width="80">
                <template slot-scope="scope">
                  <el-button plain size="small" type="primary" @click="delFile(scope.row)">删 除</el-button>
                </template>
              </el-table-column>
            </el-table>
          
          </div>
        </el-form>
        
        <!-- 新增站点 -->
        <el-dialog
          :lock-scroll="true"
          :title="popInfoTitle"
          :visible.sync="dialogVisible"
          width="50%"
        >
          <el-row :gutter="20">
            <el-form
              ref="detailForm"
              :model="stationDetailForm"
              :rules="pageConfig.formRules"
              class="detail-form"
            >
              <el-col :span="12">
                <el-form-item label="运营商：" prop="dealNo">
                  <el-select
                    v-model="stationDetailForm.dealNo"
                    class="full-width"
                    clearable
                    filterable
                    placeholder="请选择运营商名称"
                    size="small"
                    @change="handleSearchStationList"
                  >
                    <el-option
                      v-for="item in dealerArr"
                      :key="item.id"
                      :label="item.dealName"
                      :value="item.dealNo"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="站 点：" prop="stationNo">
                  <el-select
                    v-model="stationDetailForm.stationNo"
                    class="full-width"
                    clearable
                    filterable
                    placeholder="请选择站点"
                    size="small"
                    @change="handelSearchStationInfo"
                  >
                    <el-option
                      v-for="item in powerStationArr"
                      :key="item.stationNo"
                      :label="item.stationName"
                      :value="item.stationNo"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <div style="width: 100%;padding: 0 10px; box-sizing: border-box;">
                <div class="detail-body-title">公司信息</div>
                <el-table :data="tableData" :show-header="false" border stripe style="width: 100%; margin-bottom: 20px">
                  <el-table-column align="center" label="参与分成站点" prop="stationName"/>
                  <el-table-column align="center" label="分成类型" prop="splitTypeName"/>
                  <el-table-column align="center" label="分成方式" prop="amountSplitPercent"/>
                  <el-table-column align="center" label="分成周期" prop="dividedCyclesName"/>
                  <el-table-column align="center" label="提现周期" prop="payoutCyclesName"/>
                  <el-table-column align="center" label="备用金（元）" prop="reserveAmount"/>
                  <el-table-column align="center" label="分成状态" prop="splitActiveStatusName "/>
                  <el-table-column align="center" label="提现状态" prop="splitPayoutStatusName"/>
                </el-table>
              </div>
              
              <el-col :span="12">
                <el-form-item label="分成类型：" prop="splitType">
                  <el-select
                    v-model="stationDetailForm.splitType"
                    class="full-width"
                    clearable
                    filterable
                    placeholder="请选择分成类型"
                    size="small"
                  >
                    <el-option label="按充电电量分成" value="DEGREE"/>
                    <el-option label="按充电费的比例分成" value="AMOUNT"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item v-if="stationDetailForm.splitType==='DEGREE'" label="度电分成金额："
                              prop="eachDegreeSplitPrice">
                  <el-input v-model="stationDetailForm.eachDegreeSplitPrice" size="small" style="width: 90%"/>
                  元
                </el-form-item>
                <el-form-item v-if="stationDetailForm.splitType==='AMOUNT'" label="金额分成比例："
                              prop="amountSplitPercent">
                  <el-input v-model="stationDetailForm.amountSplitPercent" size="small" style="width: 90%"/>
                  %
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分成周期">
                  <div style="width: 100%; display: flex; align-items: center;justify-content: space-between">
                    <el-select
                      v-model="stationDetailForm.dividedCycles"
                      clearable
                      filterable
                      placeholder="请选择分成周期"
                      size="small"
                      style="width: 48%"
                    >
                      <el-option label="T + 1" value="PLUS_ONE"/>
                      <el-option label="T + 2" value="PLUS_TWO"/>
                      <el-option label="T + 3" value="PLUS_THREE"/>
                      <el-option label="T + 4" value="PLUS_FOUR"/>
                      <el-option label="T + 5" value="PLUS_FIVE"/>
                    </el-select>
                    <el-switch v-model="stationDetailForm.splitActiveStatus"
                               active-color="#ff4949" active-text="分成暂停" active-value="PAUSE"
                               inactive-color="#13ce66" inactive-text="分成启用" inactive-value="ACTIVE"
                               size="small"
                               @change="handleSwitchActive"/>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="提现周期">
                  <div style="width: 100%; display: flex; align-items: center;justify-content: space-between">
                    <el-select
                      v-model="stationDetailForm.payoutCycles"
                      clearable
                      filterable
                      placeholder="请选择提现周期"
                      size="small"
                      style="width: 48%"
                    >
                      <el-option label="T + 1" value="PLUS_ONE"/>
                      <el-option label="T + 2" value="PLUS_TWO"/>
                      <el-option label="T + 3" value="PLUS_THREE"/>
                      <el-option label="T + 4" value="PLUS_FOUR"/>
                      <el-option label="T + 5" value="PLUS_FIVE"/>
                      <el-option label="T + 6" value="PLUS_SIX"/>
                      <el-option label="T + 7" value="PLUS_SEVEN"/>
                    </el-select>
                    <el-switch v-model="stationDetailForm.splitPayoutStatus"
                               active-color="#ff4949" active-text="提现暂停" active-value="PAUSE"
                               inactive-color="#13ce66" inactive-text="提现启用" inactive-value="ACTIVE"
                               size="small"
                               @change="handleSwitchPayout"/>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备用金：" prop="reserveAmount">
                  <el-input v-model="stationDetailForm.reserveAmount" placeholder="请输入备用金" size="small"/>
                </el-form-item>
              </el-col>
              <el-col v-if="stationDetailForm.activeDateTime" :span="12">
                <el-form-item label="生效时间：" prop="activeDateTime">
                  <el-date-picker
                    v-model="stationDetailForm.activeDateTime"
                    placeholder="选择生效时间"
                    size="small"
                    style="width: 100%"
                    type="datetime"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <div style="width: 100%; display: flex; align-items: center;justify-content: flex-end">
                  <el-button size="small" @click="dialogVisible = false">
                    取 消
                  </el-button>
                  <el-button
                    size="small"
                    type="primary"
                    @click="addPileStation"
                  >
                    确 定
                  </el-button>
                </div>
              </el-col>
            
            </el-form>
          </el-row>
        </el-dialog>
      </div>
      <div class="detail-content-footer-div">
        <button class="common-bg-button" @click="submitForm('detailForm')">
          提 交
        </button>
        <button class="common-empty-button" @click="resetForm">取 消</button>
      </div>
    </div>
  </div>
</template>

<script>
  import pageConfig from "./page-config";
  
  export default {
    data() {
      return {
        pageConfig,
        editFlag: false, //表单是否编辑状态
        pageTitle: "清分账户详情",
        // 默认值设置
        detailForm: {
          profitShare: 0,
        },
        stationDetailForm: {
          splitType: 'DEGREE',
          corpNo: this.$store.state.corpNo,
        }, // 电站编号
        dialogVisible: false, // 新增站点弹窗
        popInfoTitle: '',
        tableData: [],
        
        stationTableData: [], // 绑定电站数据
        contractFile: null, // 上传文件
        fileList: [], // 上传文件预览地址
        
        url: "", //请求数据的url地址
        ruleArr: [], //表单验证字段
        
        dealerArr: [], // 运营商
        powerStationArr: [], // 所有站点
        
        dealerFileDtoList: [], // 合同列表
        clearAccountList: [], // 分成站点设置
      };
    },
    methods: {
      //是否为编辑模式
      init() {
        let _ = this;
        
        this.url = this.$A.cleanSettleRecord.addAccount;
        
        // 所属运营商
        _.$H.post(_, _.$A.dealer.allList, {}).then((res) => {
          _.dealerArr = res.data.data || [];
        });
        
        if (this.$route.query.editId) {
          this.editFlag = true;
          this.ruleArr = this.pageConfig.editRuleArr;
          this.getFormInfo();
        } else {
          this.ruleArr = this.pageConfig.addRuleArr;
        }
      },
      // 获取表单信息
      getFormInfo() {
        let _ = this;
        _.$S.getFormInfo(
          _,
          _.$A.cleanSettleRecord.accountDetail + _.$route.query.editId,
          function (res) {
            _.detailForm = res.data.data || {};
            _.dealerFileDtoList = _.detailForm.receiveAccountContractList || [];
            _.clearAccountList = _.detailForm.receiveAccountStationSplitConfigList || [];
          },
        );
      },
      
      // 上传合同附件
      toUploadcontractFile(param) {
        let _ = this;
        if (param) {
          this.contractFile = param.file;
          if (this.editFlag) {
            let formData = new FormData();
            formData.append("dealerNo", this.detailForm.dealNo);
            formData.append("file", this.contractFile);
            this.$H.post(this, this.$A.dealer.addattach, formData).then((res) => {
              this.dealerFileDtoList.push(res.data.data);
              _.detailForm.fileAttachDetail = res.data.data.fileAttachDetail;
            });
          }
        }
      },
      // 删除合同附件
      handleRemove(file, fileList) {
        this.contractFile = null;
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      //删除附件前提示
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      // 删除合同
      delFile(row) {
        let _ = this;
        row.dealerNo = _.detailForm.dealNo;
        _.$H.post(_, _.$A.dealer.removeattach, row).then((res) => {
          _.$U.success("删除成功");
          _.init();
        });
      },
      
      // 新增站点
      handleAddStation(title, row) {
        let _ = this;
        _.popInfoTitle = title;
        _.stationDetailForm = {
          splitType: 'DEGREE',
          corpNo: this.$store.state.corpNo,
        };
        if (row) {
          _.$H.get(_, _.$A.cleanSettleRecord.getClearAccountInfo + row.id).then((res) => {
            _.stationDetailForm = res.data.data || {};
            _.tableData = res.data.data.stationSplitConfigList || [];
            _.handleSearchStationList(_.stationDetailForm.dealNo);
          })
        }
        _.dialogVisible = true;
      },
      // 根据运营商 查询 站点
      handleSearchStationList(val) {
        let _ = this;
        if (val) {
          _.$H.get(_, _.$A.cleanSettleRecord.getStationList + val).then((res) => {
            _.powerStationArr = res.data.data || [];
          })
        }
      },
      // 根据站点编号 - 查询公司信息
      handelSearchStationInfo(val) {
        let _ = this;
        _.$H.get(_, _.$A.cleanSettleRecord.getCompanyInfo + val).then((res) => {
          _.tableData = res.data.data || [];
        })
      },
      // 启用、禁用
      handleSwitchActive(val) {
        let _ = this;
        if (val === 'PAUSE') _.stationDetailForm.splitActiveStatusName = '暂停';
        if (val === 'ACTIVE') _.stationDetailForm.splitActiveStatusName = '启用';
      },
      handleSwitchPayout(val) {
        let _ = this;
        if (val === 'PAUSE') _.stationDetailForm.splitPayoutStatusName = '暂停';
        if (val === 'ACTIVE') _.stationDetailForm.splitPayoutStatusName = '启用';
      },
      // 新增站点 - 确认
      addPileStation() {
        let _ = this;
        _.$U.showLoading(_);
        _.$H.post(_, _.$A.cleanSettleRecord.addClearAccountInfo, _.stationDetailForm).then((res) => {
          _.$U.hideLoading(_);
          _.dialogVisible = false;
          _.getFormInfo();
        })
      },
      
      // 表单提交
      submitForm(formName) {
        let _ = this;
        _.detailForm.corpNo = _.$store.state.corpNo;
        let formData = new FormData();
        Object.keys(_.detailForm).forEach((key) => {
          formData.append(key, _.detailForm[key]);
        });
        let num = 0;
        let suc = true;
        this.$refs[formName].validateField(_.ruleArr, (valid) => {
          if (valid) {
            suc = false;
          }
          num++;
          if (num == _.ruleArr.length && suc) {
            _.$S.submitForm(_, _.url, true, formData, pageConfig.listRouter);
          }
        });
      },
      // 取消
      resetForm() {
        this.$router.push({
          name: pageConfig.listRouter,
        });
      },
    },
    mounted() {
      this.init();
    },
  };
</script>
